import { registerComponent as A } from "@aileron/button-icon";
import { registerComponent as D } from "@aileron/icon";
import { unsafeCSS as C, LitElement as F, nothing as w } from "lit";
import { unsafeStatic as L, html as f } from "lit/static-html.js";
import { query as V, state as g, property as s } from "lit/decorators.js";
import { classMap as y } from "lit/directives/class-map.js";
import { ifDefined as c } from "lit/directives/if-defined.js";
import { live as T } from "lit/directives/live.js";
const B = (r) => {
  class t extends r {
    constructor(...e) {
      super(...e), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const n = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(n.getElementsByTagName("link")).findIndex(
        (h) => h.href === this.fontLink
      ) === -1) {
        const h = document.createElement("link");
        h.href = this.fontLink, h.rel = "stylesheet", document.head.appendChild(h);
      }
    }
  }
  return t;
}, z = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.static{position:static}.absolute{position:absolute}.relative{position:relative}.-mt-px{margin-top:-1px}.mt-5{margin-top:1.25rem}.box-border{box-sizing:border-box}.inline{display:inline}.flex{display:flex}.table{display:table}.hidden{display:none}.h-12{height:3rem}.h-9{height:2.25rem}.w-12{width:3rem}.w-9{width:2.25rem}.cursor-pointer{cursor:pointer}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.items-center{align-items:center}.justify-center{justify-content:center}.rounded{border-radius:.25rem}.border{border-width:1px}.border-solid{border-style:solid}.border-blue-060{border-color:#0860c4}.border-blue-070{border-color:#0a78f5}.border-blue-080{border-color:#3b93f7}.border-neutral-050{border-color:#405164}.border-neutral-090{border-color:#b4c1cf}.border-transparent{border-color:transparent}.bg-blue-060{background-color:#0860c4}.bg-blue-070{background-color:#0a78f5}.bg-blue-080{background-color:#3b93f7}.bg-neutral-010{background-color:#181e25}.bg-neutral-020{background-color:#202832}.bg-neutral-030{background-color:#28323e}.bg-neutral-040{background-color:#303d4b}.bg-neutral-050{background-color:#405164}.bg-neutral-090{background-color:#b4c1cf}.bg-neutral-100{background-color:#e6eaef}.bg-neutral-110{background-color:#eceff3}.bg-neutral-120{background-color:#f3f5f7}.bg-neutral-130{background-color:#f9fafb}.bg-transparent{background-color:transparent}.p-0{padding:0}.text-blue-060{color:#0860c4}.text-blue-080{color:#3b93f7}.text-neutral-000{color:#101419}.text-neutral-050{color:#405164}.text-neutral-090{color:#b4c1cf}.text-neutral-140{color:#fff}.outline{outline-style:solid}.outline-2{outline-width:2px}.outline-offset-2{outline-offset:2px}.outline-blue-070{outline-color:#0a78f5}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}[hidden]{display:none!important}.hover\\:border-blue-070:hover{border-color:#0a78f5}.hover\\:bg-blue-070:hover{background-color:#0a78f5}.hover\\:bg-neutral-110:hover{background-color:#eceff3}.hover\\:bg-neutral-120:hover{background-color:#f3f5f7}.hover\\:bg-neutral-130:hover{background-color:#f9fafb}.focus\\:outline:focus{outline-style:solid}.focus\\:outline-2:focus{outline-width:2px}.focus\\:outline-offset-2:focus{outline-offset:2px}.focus\\:outline-blue-070:focus{outline-color:#0a78f5}.active\\:border-blue-080:active{border-color:#3b93f7}.active\\:bg-blue-080:active{background-color:#3b93f7}.active\\:bg-neutral-100:active{background-color:#e6eaef}.active\\:bg-neutral-110:active{background-color:#eceff3}.active\\:bg-neutral-120:active{background-color:#f3f5f7}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:border-neutral-090:disabled{border-color:#b4c1cf}.disabled\\:bg-neutral-090:disabled{background-color:#b4c1cf}.disabled\\:text-neutral-090:disabled{color:#b4c1cf}.dark\\:border-blue-080:is(:host([aileron-color-scheme=dark]) *){border-color:#3b93f7}.dark\\:bg-blue-080:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:text-blue-080:is(:host([aileron-color-scheme=dark]) *){color:#3b93f7}.dark\\:text-neutral-000:is(:host([aileron-color-scheme=dark]) *){color:#101419}.dark\\:hover\\:bg-blue-070:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#0a78f5}.dark\\:hover\\:bg-neutral-010:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#181e25}.dark\\:hover\\:bg-neutral-020:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:hover\\:bg-neutral-030:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:focus\\:bg-blue-080:focus:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:active\\:border-blue-060:active:is(:host([aileron-color-scheme=dark]) *){border-color:#0860c4}.dark\\:active\\:bg-blue-060:active:is(:host([aileron-color-scheme=dark]) *){background-color:#0860c4}.dark\\:active\\:bg-neutral-020:active:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:active\\:bg-neutral-030:active:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:active\\:bg-neutral-040:active:is(:host([aileron-color-scheme=dark]) *){background-color:#303d4b}.dark\\:disabled\\:border-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){border-color:#405164}.dark\\:disabled\\:bg-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){background-color:#405164}.dark\\:disabled\\:text-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){color:#405164}', N = C(z), m = "aileron-color-scheme", $ = "aileron-color-scheme-change", I = (r) => {
  const i = class i extends r {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (n) => {
        n.detail ? this.setAttribute(m, n.detail) : this.removeAttribute(m);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        $,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const n = document.documentElement.getAttribute(
        m
      );
      n && this.setAttribute(m, n);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        $,
        this.handleSchemeSwitch
      );
    }
  };
  i.styles = [
    N,
    r.styles ?? []
  ];
  let t = i;
  return t;
}, S = I(B(F));
function b(r, t, i) {
  const e = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...i
  });
  return r.dispatchEvent(e), e;
}
function P(r, t) {
  function i(e) {
    if (!e || e === document || e === window)
      return null;
    e.assignedSlot && (e = e.assignedSlot);
    const n = e.closest(r);
    return n || i(e.getRootNode().host);
  }
  return i(t);
}
class q extends Event {
  constructor(t) {
    super("formdata"), this.formData = t;
  }
}
class M extends FormData {
  constructor(t) {
    super(t), this.form = t, t.dispatchEvent(new q(this));
  }
  append(t, i) {
    let e = this.form.elements[t];
    if (e || (e = document.createElement("input"), e.type = "hidden", e.name = t, this.form.appendChild(e)), this.has(t)) {
      const n = this.getAll(t), u = n.indexOf(e.value);
      u !== -1 && n.splice(u, 1), n.push(i), this.set(t, n);
    } else
      super.append(t, i);
    e.value = i;
  }
}
function U() {
  const r = document.createElement("form");
  let t = !1;
  return document.body.append(r), r.addEventListener("submit", (i) => {
    new FormData(i.target), i.preventDefault();
  }), r.addEventListener("formdata", () => t = !0), r.dispatchEvent(new Event("submit", { cancelable: !0 })), r.remove(), t;
}
function _() {
  !window.FormData || U() || (window.FormData = M, window.addEventListener("submit", (r) => {
    r.defaultPrevented || new FormData(r.target);
  }));
}
document.readyState === "complete" ? _() : window.addEventListener("DOMContentLoaded", () => _());
class W {
  constructor(t, i) {
    (this.host = t).addController(this), this.options = {
      form: (e) => P("form", e),
      name: (e) => e.name,
      value: (e) => e.value,
      disabled: (e) => e.disabled,
      reportValidity: (e) => typeof e.reportValidity == "function" ? e.reportValidity() : !0,
      ...i
    }, this.options.form(this.host) && (this.options.form(this.host).noValidate = !0), this.handleFormData = this.handleFormData.bind(this), this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }
  hostConnected() {
    var t;
    this.form = (t = this.options) == null ? void 0 : t.form(this.host), this.form && (this.form.addEventListener("formdata", this.handleFormData), this.form.addEventListener("submit", this.handleFormSubmit));
  }
  hostDisconnected() {
    this.form && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit), this.form = void 0);
  }
  handleFormData(t) {
    const i = this.options.disabled(this.host), e = this.options.name(this.host), n = this.options.value(this.host);
    !i && typeof e == "string" && typeof n < "u" && (Array.isArray(n) ? n.forEach((u) => {
      t.formData.append(e, u.toString());
    }) : t.formData.append(e, n.toString()));
  }
  handleFormSubmit(t) {
    const i = this.options.disabled(this.host);
    this.form && !i && (t.preventDefault(), t.stopImmediatePropagation());
  }
  submit(t) {
    if (this.form) {
      const i = document.createElement("button");
      i.type = "submit", i.style.position = "absolute", i.style.width = "0", i.style.height = "0", i.style.clipPath = "inset(50%)", i.style.overflow = "hidden", i.style.whiteSpace = "nowrap", t && ["formaction", "formmethod", "formnovalidate", "formtarget"].forEach((e) => {
        t.hasAttribute(e) && i.setAttribute(e, t.getAttribute(e));
      }), this.form.append(i), i.click(), i.remove();
    }
  }
}
class R {
  constructor(t, ...i) {
    this.slotNames = [], (this.host = t).addController(this), this.slotNames = i, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => {
      var i;
      if (t.nodeType === t.TEXT_NODE && ((i = t.textContent) == null ? void 0 : i.trim()) !== "")
        return !0;
      if (t.nodeType === t.ELEMENT_NODE) {
        const e = t;
        if (e.tagName.toLowerCase() === "adc-visually-hidden")
          return !1;
        if (!e.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(t) {
    return this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    var t;
    (t = this.host.shadowRoot) == null || t.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    var t;
    (t = this.host.shadowRoot) == null || t.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    var e, n;
    const i = t.target;
    ((e = this.slotNames) != null && e.includes("[default]") && !i.name || i.name && ((n = this.slotNames) != null && n.includes(i.name))) && this.host.requestUpdate();
  }
}
class O {
  constructor(t) {
    this.userAgent = t;
  }
  getDevice() {
    return this.userAgent.match(/iPad/i) ? "iPad" : this.userAgent.match(/iPhone/i) ? "iPhone" : this.userAgent.match(/iPod/i) ? "iPod" : this.userAgent.match(/Android/i) ? "Android" : "Unknown";
  }
  getBrowser() {
    return this.userAgent.match(/chrome|chromium|crios/i) ? "Chrome" : this.userAgent.match(/firefox|fxios/i) ? "Firefox" : this.userAgent.match(/opr\//i) ? "Opera" : this.userAgent.match(/edg/i) ? "Edge" : this.userAgent.match(/safari/i) ? "Safari" : "Unknown";
  }
}
function E(r, t) {
  const i = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (e, n) => {
    const { update: u } = e;
    if (r in e) {
      const p = r;
      e.update = function(h) {
        if (h.has(p)) {
          const x = h.get(p), k = this[p];
          x !== k && (!i.waitUntilFirstUpdate || this.hasUpdated) && this[n](
            x,
            k
          );
        }
        u.call(this, h);
      };
    }
  };
}
const K = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let H = (r = 21) => {
  let t = "", i = crypto.getRandomValues(new Uint8Array(r |= 0));
  for (; r--; )
    t += K[i[r] & 63];
  return t;
};
const j = '.aileron-text-input__form-wrapper{display:flex;flex-direction:column;gap:8px}.aileron-text-input__error-icon{color:#d6001b;margin-right:4px}.aileron-text-input__label{font-weight:500;font-size:.875rem;line-height:1.25rem;text-transform:none;color:#5e6d7a;font-family:AmericanSans Var;display:inline-flex;align-items:center}.aileron-text-input__input-wrapper{font-family:AmericanSans Var;font-weight:400;font-size:1rem;line-height:1.5rem;text-transform:none;display:flex;flex-direction:row;align-items:center;border-radius:4px;border:1px solid #869199;padding-left:12px;background-color:#fff}.aileron-text-input__input-wrapper:hover{background-color:#e0f2ff}.aileron-text-input__input-wrapper:active{outline:2px #006DC0 solid;outline-offset:2px;background-color:#d6edff}.aileron-text-input--focus{outline:2px #3AABFF solid;outline-offset:2px}.aileron-text-input__leading-icon{color:#1b1f23;padding:12px 8px 12px 0;display:inline-block}.aileron-text-input__trailing-icon{padding-top:1px;padding-right:4px}.aileron-text-input__input{background-color:inherit;padding-block:12px;flex-grow:1;border-radius:4px;width:100%}.aileron-text-input__input:active{outline:0;border:0}.aileron-text-input__input:focus{outline:0}.aileron-text-input__input--hidden{display:none}.aileron-text-input__clear-button{display:inline-block;color:#006dc0;padding:12px;border-radius:4px}.aileron-text-input__clear-button:focus{outline:2px #3AABFF solid;outline-offset:-2px}.aileron-text-input__error-text{font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-weight:400;font-variation-settings:"wght" 400;font-size:.75rem;line-height:1rem;text-transform:none;color:#d6001b}.aileron-text-input__help-text{font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-weight:400;font-variation-settings:"wght" 400;font-size:.75rem;line-height:1rem;text-transform:none}.aileron-text-input--disabled .aileron-text-input{background-color:#edf1f3;border-color:#e6ecef}.aileron-text-input--disabled .aileron-text-input:placeholder{color:#d0dae0}.aileron-text-input--disabled .aileron-text-input__leading-icon,.aileron-text-input--disabled .aileron-text-input__input{color:#d0dae0}.aileron-text-input--disabled .aileron-text-input__input-wrapper{background-color:#edf1f3;border-color:#e6ecef}.aileron-text-input--readonly .aileron-text-input__input-wrapper{background-color:#edf1f3}.aileron-text-input--invalid .aileron-text-input__input-wrapper{border-color:#d6001b}.aileron-text-input--required .aileron-text-input__label:after{display:inline-block;content:"";background-color:#d6001b;border-radius:9999px;height:.375rem;width:.375rem;margin-left:.25rem;box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:host{display:flex;width:100%;flex-direction:column}';
var X = Object.defineProperty, G = Object.getOwnPropertyDescriptor, a = (r, t, i, e) => {
  for (var n = e > 1 ? void 0 : e ? G(t, i) : t, u = r.length - 1, p; u >= 0; u--)
    (p = r[u]) && (n = (e ? p(t, i, n) : p(n)) || n);
  return e && n && X(t, i, n), n;
};
const d = "aileron-text-input", l = {
  formWrapper: `${d}__form-wrapper`,
  inputWrapper: `${d}__input-wrapper`,
  input: `${d}__input`,
  label: `${d}__label`,
  helpText: `${d}__help-text`,
  clearButton: `${d}__clear-button`,
  leadingIcon: `${d}__leading-icon`,
  trailingIcon: `${d}__trailing-icon`,
  errorIcon: `${d}__error-icon`,
  errorText: `${d}__error-text`,
  disabled: `${d}--disabled`,
  readonly: `${d}--readonly`,
  required: `${d}--required`,
  invalid: `${d}--invalid`,
  hidden: `${d}--hidden`,
  focus: `${d}--focus`
}, v = class v extends S {
  constructor(t) {
    super(), this.formSubmitController = new W(this), this.hasSlotController = new R(
      this,
      "label",
      "button-icon",
      "helper-text",
      "validity-message"
    ), this.randomId = `adc-input-${H(6)}`, this.focusWithin = !1, this.isPasswordVisible = !1, this.pristine = !0, this.dirty = !1, this.isComboBox = !1, this.id = "", this.labelText = "", this.type = "text", this.autofocus = !1, this.readonly = !1, this.disabled = !1, this.required = !1, this.invalid = !1, this.helperText = "", this.requiredValidityMessage = "Please fill out this field", this.validityMessage = "", this.liveValidation = !1, this.hideClearButton = !1, this.value = "", this.leadingIcon = "", this.a11yLiveError = "polite", this.customElementString = t;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-text-input"), A(
      this.customElementString ? this.customElementString + "-text-input" : "adc-text-input"
    ), D(
      this.customElementString ? this.customElementString + "-text-input" : "adc-text-input"
    );
  }
  get valueAsDate() {
    var t;
    return ((t = this.input) == null ? void 0 : t.valueAsDate) ?? null;
  }
  set valueAsDate(t) {
    this.updateComplete.then(() => {
      this.input.valueAsDate = t, this.value = this.input.value;
    });
  }
  get valueAsNumber() {
    var t;
    return ((t = this.input) == null ? void 0 : t.valueAsNumber) ?? parseFloat(this.value);
  }
  set valueAsNumber(t) {
    this.updateComplete.then(() => {
      this.input.valueAsNumber = t, this.value = this.input.value;
    });
  }
  clear() {
    this.dirty = !1, this.value = "", this.focus(), this.browser === "safari" && setTimeout(() => {
      this.focusWithin = !0;
    }, 210), b(this, "adc-clear");
  }
  focus(t) {
    this.input.focus(t);
  }
  blur() {
    this.input.blur(), this.pristine = !1;
  }
  select() {
    this.input.select();
  }
  setSelectionRange(t, i, e = "none") {
    this.input.setSelectionRange(
      t,
      i,
      e
    );
  }
  setRangeText(t, i, e, n = "preserve") {
    this.input.setRangeText(t, i, e, n), this.value !== this.input.value && (this.value = this.input.value, b(this, "adc-input"), b(this, "adc-change"));
  }
  reportValidity() {
    return this.input.reportValidity();
  }
  setCustomValidity(t) {
    if (t != null && t.trim()) {
      this.invalid = !0, this.validityMessage = t;
      return;
    } else
      this.invalid = !1, this.validityMessage = "";
  }
  handleBlur() {
    this.browser === "safari" ? setTimeout(() => {
      this.focusWithin = !1;
    }, 200) : this.focusWithin = !1;
  }
  handleInputBlur() {
    this.handleValidity(), this.focusWithin = !1, b(this, "adc-blur");
  }
  handleChange() {
    this.value = this.input.value, this.handleValidity(), b(this, "adc-change");
  }
  handleDisabledChange() {
    this.input.disabled = this.disabled, this.invalid = !this.input.checkValidity();
  }
  handleFocus() {
    this.focusWithin = !0, this.renderRoot.querySelector(`.${l.inputWrapper}`).classList.add(l.focus), b(this, "adc-focus");
  }
  handleInput() {
    this.dirty = !0, this.value = this.input.value, this.setCustomValidity(""), this.handleValidity(), b(this, "adc-input");
  }
  handleInvalid() {
    this.invalid = !0;
  }
  handleValidity() {
    this.pristine = !1, this.liveValidation && (this.invalid = !this.input.checkValidity());
  }
  handleKeyDown(t) {
    const i = t.altKey || t.ctrlKey || t.metaKey || t.shiftKey;
    t.key === "Enter" && !i && (this.formSubmitController.submit(), this.handleValidity());
  }
  handlePasswordToggle() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  handleValueChange() {
    this.pristine = !1, this.value && (this.dirty = !0), setTimeout(() => {
      this.invalid = !this.input.checkValidity();
    }, 0);
  }
  createTagName(t) {
    return L(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  renderClearButton() {
    return !this.hideClearButton && this.dirty ? f`
      <button
        id="clear-button"
        name="button-icon"
        class="${y({
      [l.clearButton]: !0,
      [l.hidden]: this.focusWithin
    })}"
        ?disabled=${this.disabled}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="clear entry"
        type="button"
        @click=${() => {
      this.clear();
    }}
      >
        <${this.createTagName("-text-input-icon")}
          exportparts="icon"
          outlined
          size="24"
          icon="action:close"
        ></${this.createTagName("-text-input-icon")}>
      </button>` : w;
  }
  render() {
    const t = this.hasSlotController.test("label"), i = this.hasSlotController.test("helper-text"), e = this.labelText ? !0 : !!t, n = this.helperText ? !0 : !!i;
    return f`
      <div
        class="${y({
      [l.formWrapper]: !0,
      [l.disabled]: this.disabled,
      [l.readonly]: this.readonly,
      [l.invalid]: this.invalid,
      [l.required]: this.required
    })}"
      >
        <label
          part="form-control-label"
          class=${l.label}
          for="${c(this.inputId ? this.inputId : this.randomId)}"
          aria-hidden=${e ? "false" : "true"}
        >
          ${this.invalid ? f`<${this.createTagName("-text-input-icon")}
              exportparts="icon: label-error-icon"
              icon="signal:error"
              class="aileron-text-input__error-icon"
            ></${this.createTagName("-text-input-icon")}>` : void 0}
          <slot name="label">${this.labelText}</slot>
        </label>

        <div
          class="${y({
      [l.inputWrapper]: !0,
      [l.focus]: this.focusWithin
    })}"
        >
          ${this.leadingIcon ? f`
              <div class=${l.leadingIcon}>
              <${this.createTagName("-text-input-icon")}
                part="icon"

                icon=${this.leadingIcon}
                size="24"
              ></${this.createTagName("-text-input-icon")}>
              </div>
            ` : w}

          <input
            part="input"
            id="${c(this.inputId ? this.inputId : this.randomId)}"
            class=${l.input}
            type=${this.type === "password" && this.isPasswordVisible ? "text" : this.type}
            name=${c(this.name)}
            .autocomplete=${this.autocomplete}
            ?autofocus=${this.autofocus}
            min=${c(this.min)}
            max=${c(this.max)}
            minlength=${c(this.minLength)}
            maxlength=${c(this.maxLength)}
            pattern=${c(this.pattern)}
            placeholder=${c(this.placeholder)}
            ?readonly=${this.readonly}
            ?required=${this.required}
            .value=${T(this.value)}
            inputmode=${c(this.inputMode)}
            step=${c(this.step)}
            @input=${this.handleInput}
            @change=${this.handleChange}
            @blur=${this.handleInputBlur}
            @focus=${this.handleFocus}
            @keydown=${this.handleKeyDown}
            @invalid=${this.handleInvalid}
            aria-invalid=${this.invalid ? "true" : "false"}
            spellcheck=${c(this.spellcheck)}
            aria-describedby=${c(this.helperText && "helper-text")}
            aria-label="${c(this.a11yLabel)}"
            aria-description="${c(this.a11yDescription)}"
          />

          ${this.renderClearButton()}
          <span class="${l.trailingIcon}">
            <slot name="button-icon"></slot>
          </span>
        </div>

        ${this.invalid ? f`
              <div
                id="formRequirement"
                class=${l.errorText}
                aria-live="${this.a11yLiveError}"
              >
                <slot name="validity-message">
                  ${this.validityMessage || this.requiredValidityMessage}
                </slot>
              </div>
            ` : w}
        <div
          part="form-control-helper-text"
          id="helper-text"
          class=${l.helpText}
          aria-hidden=${n ? "false" : "true"}
        >
          <slot name="helper-text"> ${this.helperText}</slot>
        </div>
      </div>
    `;
  }
  /**
   * To support ie11, when an input is disabled we have to set
   * the value to "disabled" on the attribute. This happens
   * on first render.
   * @param changedProperties
   */
  async firstUpdated(t) {
    await new Promise((e) => setTimeout(e, 0)), this.addEventListener("blur", this.handleBlur), t.has("disabled") && (this.disabled ? this.input.setAttribute("disabled", "disabled") : this.input.removeAttribute("disabled")), t.has("comboBox") && this.isComboBox && this.input.setAttribute("role", "combobox");
    const i = new O(navigator.userAgent);
    this.browser = i.getBrowser().toLowerCase();
  }
  /**
   * To support ie11, when an input is disabled we have to set
   * the value to "disabled" on the attribute. This happens
   * on disabled property change.
   * @param changedProperties
   */
  updated(t) {
    t.has("pristine") && this.liveValidation && !this.pristine && (this.invalid = !this.input.checkValidity()), this.hasSlotController.test("button-icon") && this.querySelectorAll("[slot='button-icon']").forEach((e) => {
      e.kind = "ghost", e.size = "sm", e.disabled = this.disabled;
    }), t.has("disabled") && (this.disabled ? this.input.setAttribute("disabled", "disabled") : this.input.removeAttribute("disabled"));
  }
};
v.styles = [S.styles || [], C(j)];
let o = v;
a([
  V("input")
], o.prototype, "input", 2);
a([
  g()
], o.prototype, "focusWithin", 2);
a([
  g()
], o.prototype, "isPasswordVisible", 2);
a([
  g()
], o.prototype, "pristine", 2);
a([
  g()
], o.prototype, "dirty", 2);
a([
  s()
], o.prototype, "autocomplete", 2);
a([
  s({ type: Boolean, reflect: !0 })
], o.prototype, "isComboBox", 2);
a([
  s()
], o.prototype, "name", 2);
a([
  s()
], o.prototype, "pattern", 2);
a([
  s({ type: Number })
], o.prototype, "step", 2);
a([
  s()
], o.prototype, "id", 2);
a([
  s()
], o.prototype, "min", 2);
a([
  s()
], o.prototype, "max", 2);
a([
  s({ attribute: "min-length", type: Number })
], o.prototype, "minLength", 2);
a([
  s({ attribute: "max-length", type: Number })
], o.prototype, "maxLength", 2);
a([
  s({ attribute: "label-text" })
], o.prototype, "labelText", 2);
a([
  s({ reflect: !0 })
], o.prototype, "type", 2);
a([
  s()
], o.prototype, "placeholder", 2);
a([
  s({ type: Boolean })
], o.prototype, "autofocus", 2);
a([
  s({ type: Boolean, reflect: !0 })
], o.prototype, "readonly", 2);
a([
  s({ type: Boolean, reflect: !0 })
], o.prototype, "disabled", 2);
a([
  s({ type: Boolean, reflect: !0 })
], o.prototype, "required", 2);
a([
  s({ type: Boolean })
], o.prototype, "spellcheck", 2);
a([
  s({ type: Boolean, reflect: !0 })
], o.prototype, "invalid", 2);
a([
  s({ attribute: "helper-text" })
], o.prototype, "helperText", 2);
a([
  s({ attribute: "required-validity-message" })
], o.prototype, "requiredValidityMessage", 2);
a([
  s({ attribute: "validity-message" })
], o.prototype, "validityMessage", 2);
a([
  s({ type: Boolean, attribute: "live-validation", reflect: !0 })
], o.prototype, "liveValidation", 2);
a([
  s({ type: Boolean, attribute: "hide-clear-button", reflect: !0 })
], o.prototype, "hideClearButton", 2);
a([
  s()
], o.prototype, "inputmode", 2);
a([
  s({ type: String, reflect: !0 })
], o.prototype, "value", 2);
a([
  s({ type: String, attribute: "leading-icon", reflect: !0 })
], o.prototype, "leadingIcon", 2);
a([
  s({ attribute: "a11y-live-error", reflect: !0 })
], o.prototype, "a11yLiveError", 2);
a([
  s({ type: String, attribute: "input-id", reflect: !0 })
], o.prototype, "inputId", 2);
a([
  s({ type: String, attribute: "a11y-label", reflect: !0 })
], o.prototype, "a11yLabel", 2);
a([
  s({ type: String, attribute: "a11y-description", reflect: !0 })
], o.prototype, "a11yDescription", 2);
a([
  E("disabled", { waitUntilFirstUpdate: !0 })
], o.prototype, "handleDisabledChange", 1);
a([
  E("value", { waitUntilFirstUpdate: !0 })
], o.prototype, "handleValueChange", 1);
try {
  customElements.define("adc-text-input", o), console.warn(
    "@aileron/text-input is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/text-input"
  );
} catch {
}
function J(r) {
  try {
    customElements.define(
      `${r}-text-input`,
      class extends o {
        constructor() {
          super(r);
        }
      }
    );
  } catch {
  }
}
function nt(r) {
  try {
    J(r);
  } catch {
  }
}
export {
  o as TextInput,
  nt as registerComponent,
  J as registerTextInput
};
